import { useState } from 'react'
import { Send, X, ShieldCheck, Stethoscope } from 'lucide-react'
import toast from 'react-hot-toast'
import api from '../../../services/api'

export default function ShareModal({ itemType, itemId, itemTitle, patient, onClose }) {
    const[selectedMember, setSelectedMember] = useState('')
    const [message, setMessage] = useState('')
    const[loading, setLoading] = useState(false)

    const handleShare = async () => {
        if (!selectedMember) return toast.error("Veuillez sélectionner un destinataire")
        
        setLoading(true)
        try {
            await api.post('/api/share/', {
                item_type: itemType, // 'note' ou 'document'
                item_id: itemId,
                member_id: parseInt(selectedMember),
                message: message
            })
            toast.success("Document transmis de manière sécurisée !")
            onClose()
        } catch (error) {
            toast.error(error.response?.data?.detail || "Erreur lors du partage")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[70] p-4 backdrop-blur-sm">
            <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl overflow-hidden animate-in zoom-in-95">
                <div className="p-4 border-b border-gray-100 flex justify-between items-center bg-blue-50">
                    <h3 className="font-serif font-bold text-lg text-blue-900 flex items-center gap-2">
                        <ShieldCheck className="w-5 h-5 text-blue-600" /> Partage Sécurisé
                    </h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X className="w-5 h-5"/></button>
                </div>

                <div className="p-6 space-y-5">
                    <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 text-sm">
                        <span className="text-[10px] font-bold text-gray-500 uppercase block mb-1">Document à transmettre</span>
                        <span className="font-bold text-gray-800">{itemTitle}</span>
                        <span className="text-gray-500 ml-1">({patient.first_name} {patient.last_name})</span>
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Destinataire (Équipe du patient)</label>
                        {patient.care_network && patient.care_network.length > 0 ? (
                            <select 
                                value={selectedMember} 
                                onChange={(e) => setSelectedMember(e.target.value)}
                                className="w-full bg-blue-50/30 border-blue-200 focus:ring-blue-300 py-3"
                            >
                                <option value="">Sélectionnez un confrère...</option>
                                {patient.care_network.map(m => (
                                    <option key={m.id} value={m.id}>{m.first_name} {m.last_name} - {m.specialty}</option>
                                ))}
                            </select>
                        ) : (
                            <div className="text-sm text-orange-600 bg-orange-50 p-3 rounded-lg border border-orange-200 flex items-start gap-2">
                                <Stethoscope className="w-4 h-4 mt-0.5 shrink-0" />
                                Aucun confrère n'est lié à ce dossier. Allez dans la fiche du patient pour ajouter un membre à son équipe.
                            </div>
                        )}
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Message d'accompagnement (Optionnel)</label>
                        <textarea 
                            rows={3} 
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Bonjour cher confrère, voici le bilan..."
                            className="w-full border-gray-200 focus:ring-blue-300"
                        />
                    </div>

                    <button 
                        onClick={handleShare}
                        disabled={loading || !selectedMember}
                        className="w-full btn bg-blue-600 hover:bg-blue-700 text-white flex justify-center items-center gap-2 py-3 shadow-md disabled:opacity-50"
                    >
                        {loading ? <div className="spinner w-4 h-4 border-white" /> : <><Send className="w-4 h-4" /> Envoyer le lien sécurisé</>}
                    </button>
                    <p className="text-[10px] text-center text-gray-400 mt-2">Le lien envoyé expirera automatiquement après 7 jours (Normes HDS).</p>
                </div>
            </div>
        </div>
    )
}